import { render, staticRenderFns } from "./DaiR_Search.vue?vue&type=template&id=460cac53"
import script from "./DaiR_Search.vue?vue&type=script&lang=js"
export * from "./DaiR_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports